import React, { PropsWithChildren } from "react";
import { Hero } from "components/generic/Hero";

interface Props {
    title: string;
    description: string;
}

/**
 * A simple error page with a title and description, which can be extended with arbitrary children
 */
export const ErrorPage: React.FC<PropsWithChildren<Props>> = props => {
    return (
        <div className="row">
            <div className="col-12">
                <Hero heading={props.title} description={props.description}>
                    {props.children}
                </Hero>
            </div>
        </div>
    );
};
